import React, { useEffect } from "react";
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Images } from "../../../assets";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faPhone,
  faEnvelope,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import "./footer.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getSiteSettingData,
  isSubscribed,
} from "../../../redux/site-settings/action";
import { resendEmailSchema } from "../../../validation/validationSchema";
import { useTranslation } from "react-i18next";

function Footer({
  increaseFontSize,
  decreaseFontSize,
  toggleTheme,
  toggleColorlessMode,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const siteSettings = useSelector((state) => state.siteSettings);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(resendEmailSchema),
  });

  const handleFormSubmit = (data) => {
    if (data.email.trim()) {
      dispatch(isSubscribed(data.email));
      reset();
    }
  };

  return (
    <footer className="footer text-white position-relative">
      <div className="top-sec">
        <Container className="custom-container" id="footer">
          <Row className="gy-4">
            <Col lg={4} sm={7} data-aos="fade-up" data-aos-delay="100">
              <div className="logo-content-wrapper">
                {/* <div className="mb-xl-5 mb-4"> */}
                {/* <strong className="d-inline-block mb-lg-4 mb-3">
                    <Link to="#" className="d-inline-block">
                      <Image
                        src={siteSettings?.siteSettingsData?.logo}
                        alt="logo"
                        loading="lazy"
                        fluid
                      />
                    </Link>
                  </strong> */}
                {/* <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam.
                  </p> */}
                {/* </div> */}
                <div className="social-contact mb-4">
                  <h4 className="mb-3">{t("footer.socialContact")}</h4>
                  <ul className="social-icons list-unstyled mb-0 d-flex gap-3">
                    {siteSettings?.siteSettingsData?.socialContacts?.length &&
                      siteSettings?.siteSettingsData?.socialContacts?.map(
                        (contact, index) => {
                          return (
                            <li key={index}>
                              <a
                                href={contact?.attributeValue || "#"}
                                className="text-white text-decoration-none d-inline-flex align-items-center justify-content-center"
                              >
                                <Image
                                  src={contact?.icon}
                                  alt="social icon"
                                  loading="lazy"
                                  className="img-fluid"
                                />
                              </a>
                            </li>
                          );
                        },
                      )}
                  </ul>
                </div>
                <form
                  onSubmit={handleSubmit(handleFormSubmit)}
                  className={`newsletter-form ${siteSettings?.isSubmit ? "submit" : ""}`}
                >
                  <h4 className="mb-3">{t("footer.subscribeNewsletter")}</h4>
                  <div className="position-relative">
                    <Form.Group className="input-group">
                      <Form.Control
                        className="newsletter-email input-text"
                        type="email"
                        placeholder={t("footer.enterEmailAddress")}
                        {...register("email")}
                        disabled={siteSettings?.isSubmit}
                        autoComplete="off"
                        autoCorrect="off"
                      />
                      {errors.email && (
                        <span className="text-danger">
                          {errors.email.message}
                        </span>
                      )}
                    </Form.Group>
                    <button className="btn-newsletter-submit btn" type="submit">
                      <span className="subscribe-text">
                        {t("footer.subscribe")}
                      </span>
                      <span className="thanks-message">
                        {t("footer.thankYouForSubscribing")}
                      </span>
                    </button>
                  </div>
                </form>
              </div>
            </Col>
            <Col lg={3} sm={5} data-aos="fade-up" data-aos-delay="300">
              <div className="content-wrapper">
                <h4 className="title">{t("footer.usefulLinks")}</h4>
                <ul className="footer-links list-unstyled mb-0">
                  {siteSettings?.siteSettingsData?.usefulLinks?.length > 0 &&
                    siteSettings?.siteSettingsData?.usefulLinks?.map(
                      (link, index) => {
                        return (
                          <li key={index} className="mb-xl-4 mb-md-3 mb-2">
                            <Link
                              to={link?.value}
                              className="text-decoration-none"
                            >
                              {link?.name}
                            </Link>
                          </li>
                        );
                      },
                    )}
                </ul>
              </div>
            </Col>
            <Col lg={5} data-aos="fade-up" data-aos-delay="400">
              <div className="content-wrapper">
                <h4 className="title">{t("footer.contactUs")}</h4>
                <ul className="contact-info list-unstyled mb-0">
                  {siteSettings?.siteSettingsData?.contactUs?.map(
                    (contact, index) => {
                      const isLocation = contact?.attributeName === "Location";
                      return (
                        <>
                          {isLocation &&
                            siteSettings?.siteSettingsData?.hours && (
                              <li className="d-inline-flex">
                                {/* <h4 className="title mb-3">Working Hours</h4> */}
                                <FontAwesomeIcon
                                  icon={faClock}
                                  className="mt-1 me-3"
                                />
                                <div
                                  className="ck-content-wrapper text-white mb-0"
                                  dangerouslySetInnerHTML={{
                                    __html: siteSettings.siteSettingsData.hours,
                                  }}
                                ></div>
                              </li>
                            )}

                          <li key={index} className="mb-md-3 mb-2">
                            <Link
                              to={
                                contact?.attributeName === "Phone"
                                  ? `tel:${contact?.attributeValue || "#"}`
                                  : contact?.attributeName === "Email"
                                    ? `mailto:${contact?.attributeValue || "#"}`
                                    : contact?.attributeName === "Location"
                                      ? `https://www.google.com/maps/place/${contact?.attributeValue || "#"}`
                                      : "#"
                              }
                              target={
                                contact?.attributeName === "Location"
                                  ? "_blank"
                                  : "_self"
                              }
                              className={`d-inline-flex align-items-center text-decoration-none ${
                                contact?.attributeName === "Office Hours"
                                  ? "text-white no-hover"
                                  : ""
                              }`}
                              rel="noreferrer"
                            >
                              <>
                                <FontAwesomeIcon
                                  icon={
                                    contact?.attributeName === "Phone"
                                      ? faPhone
                                      : contact?.attributeName === "Email"
                                        ? faEnvelope
                                        : contact?.attributeName === "Location"
                                          ? faLocationDot
                                          : contact?.attributeName ===
                                              "Office Hours"
                                            ? faClock
                                            : ""
                                  }
                                  className="text-white me-3"
                                />
                                {contact?.attributeValue}
                              </>
                            </Link>
                          </li>
                        </>
                      );
                    },
                  )}
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bottom-sec text-center text-white">
        <Container>
          <p className="mb-0">
            {t("footer.copyrightPrefix")} {new Date().getFullYear()} RAKMAC |{" "}
            {t("footer.allRightsReserved")}
          </p>
        </Container>
      </div>
    </footer>
  );
}

export default Footer;
